const getOrigin = () => process.env.VUE_APP_OLD_VERSION_URL || window.location.origin

const getParam = (param, context) => context.$route.params[param] || ''
const getQuery = (param, context) => context.$route.query[param] || ''

const openRouteInNewTab = (context, path) => {
    const { href } = context.$router.resolve(path)
    window.open(href, '_blank')
}

export const getSubdomain = () => {
    return window.origin.split('/')[2].split('.')[0]
}

export const redirect = (to) => {
    return window.location.replace(to)
}

export { getParam, getQuery, getOrigin, openRouteInNewTab }
